import { useState } from "react";
import { Upload } from "lucide-react";
import { uploadImage } from "../lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const resolveSrc = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  return `${BACKEND}${src}`;
};

export const ImageUpload = ({ value, onChange, testid = "image-upload" }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setError("");
    try {
      const { url } = await uploadImage(file);
      onChange(url);
    } catch (err) {
      setError("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-4">
        {value ? (
          <img
            src={resolveSrc(value)}
            alt="preview"
            className="w-20 h-20 object-cover border border-amf-gold/40"
          />
        ) : (
          <div className="w-20 h-20 border border-dashed border-amf-stone/50 flex items-center justify-center text-amf-stone">
            <Upload size={20} />
          </div>
        )}
        <label className="cursor-pointer">
          <span className="amf-overline text-amf-burgundy border border-amf-burgundy px-4 py-2 inline-block hover:bg-amf-burgundy hover:text-amf-cream transition-colors">
            {uploading ? "Uploading…" : "Upload Image"}
          </span>
          <input
            type="file"
            accept="image/*"
            onChange={handleFile}
            className="hidden"
            data-testid={testid}
          />
        </label>
      </div>
      <input
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="…or paste an image URL"
        className="w-full bg-transparent border-b border-amf-navy/20 py-1.5 px-0 text-sm font-lora focus:outline-none focus:border-amf-burgundy"
      />
      {error && <p className="text-xs text-amf-burgundy">{error}</p>}
    </div>
  );
};
